/**
 * MERKEZI ŞİFRE VALIDASYON SİSTEMİ
 * 
 * Bu dosya tüm projede kullanılacak şifre validasyon kurallarını içerir.
 * Yeni sayfalar oluşturulurken bu utility kullanılmalıdır.
 * 
 * Kullanım:
 * import { validatePassword, validatePasswordMatch } from '../utils/passwordValidation';
 * 
 * const error = validatePassword(password);
 * const matchError = validatePasswordMatch(password, confirmPassword);
 */

/**
 * Şifre validasyon kuralları
 * @param {string} password - Kontrol edilecek şifre
 * @returns {string} Hata mesajı (boş string = geçerli)
 */
export const validatePassword = (password) => {
  if (!password) {
    return ''; // Boş şifre için hata gösterme (zorunluluk kontrolü ayrı yapılmalı)
  }

  if (password.length < 8) {
    return 'Şifre en az 8 karakter olmalıdır';
  }

  if (!/[A-Z]/.test(password)) {
    return 'Şifre en az 1 büyük harf içermelidir';
  }

  if (!/[a-z]/.test(password)) {
    return 'Şifre en az 1 küçük harf içermelidir';
  }

  if (!/[0-9]/.test(password)) {
    return 'Şifre en az 1 rakam içermelidir';
  }

  if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
    return 'Şifre en az 1 özel karakter içermelidir (!@#$%^&* vb.)';
  }

  return ''; // Geçerli
};

/**
 * Şifre eşleşme kontrolü
 * @param {string} password - Ana şifre
 * @param {string} confirmPassword - Doğrulama şifresi
 * @returns {string} Hata mesajı (boş string = eşleşiyor)
 */
export const validatePasswordMatch = (password, confirmPassword) => {
  if (!confirmPassword) {
    return ''; // Boş confirmation için hata gösterme
  }

  if (password !== confirmPassword) {
    return 'Şifreler eşleşmiyor';
  }

  return ''; // Eşleşiyor
};

/**
 * Şifre güç seviyesi hesaplama (opsiyonel - gelecekte kullanılabilir)
 * @param {string} password
 * @returns {object} { strength: 'weak'|'medium'|'strong', score: 0-100 }
 */
export const calculatePasswordStrength = (password) => {
  let score = 0;

  if (password.length >= 8) score += 20;
  if (password.length >= 12) score += 10;
  if (/[A-Z]/.test(password)) score += 15;
  if (/[a-z]/.test(password)) score += 15;
  if (/[0-9]/.test(password)) score += 15;
  if (/[!@#$%^&*(),.?":{}|<>]/.test(password)) score += 15;
  if (password.length >= 16) score += 10;

  let strength = 'weak';
  if (score >= 70) strength = 'strong';
  else if (score >= 50) strength = 'medium';

  return { strength, score };
};
